const RootScreen = require("./views/RootScreen");
// Screens of page: Main
const Home = require("./views/Main/Home");
const SFP = require("./views/Main/SFP");
const Project = require("./views/Main/Project");
const Presto = require("./views/Main/Presto");
const Home2 = require("./views/Main/Home2");

// Screens of page: Mobile
const MobileHome = require("./views/Mobile/MobileHome");
const MobileSFP = require("./views/Mobile/MobileSFP");
const MobileProject = require("./views/Mobile/MobileProject");
const MobilePresto = require("./views/Mobile/MobilePresto");
const MobileHome2 = require("./views/Mobile/MobileHome2");

const screens = {
	Home,
	SFP,
	Project,
	Presto,
	Home2,
	MobileHome,
	MobileSFP,
	MobileProject,
	MobilePresto,
	MobileHome2,
	RootScreen
};

var screen;

if (window.__WIDTH <= 600)
	screen = "MobileHome2";
else
	screen = "Home2";

if(window.location.hash == "#Presto"){
	if (window.__WIDTH <= 600)
		screen = "MobilePresto";
	else
		screen = "Presto";
}

const INIT_UI = screen;

module.exports = {
	screens,
	INIT_UI
};



// WEBPACK FOOTER //
// ./screenMeta.js